export class SendSmsPreviewRequest {
  message?: string;
  smsMessageType?: String;
  customerId?: number;
  orderId?: number;
}
